import { render, staticRenderFns } from "./ContentFilterPillsList.vue?vue&type=template&id=9d5546e6&scoped=true&"
import script from "./ContentFilterPillsList.vue?vue&type=script&lang=js&"
export * from "./ContentFilterPillsList.vue?vue&type=script&lang=js&"
import style0 from "./ContentFilterPillsList.vue?vue&type=style&index=0&id=9d5546e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5546e6",
  null
  
)

export default component.exports